import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import Modal from "react-bootstrap/Modal"
import gql from "graphql-tag"
import $ from "jquery";
import { Helmet } from "react-helmet"

import PropertyNav from "../components/PropertyDetails/PropertyNav";
import StickyNav from "../components/PropertyDetails/StickyNav/StickyNav"
import BannerBottom from "../components/SearchListing/BannerBottom"
import Avenue from "../components/PropertyDetails/Avenue/Avenue";
import Description from "../components/PropertyDetails/PropertyDescription/Description";
import Calculator from "../components/PropertyDetails/Calculator/Calculator";
import Connect from "../components/PropertyDetails/Connect/Connect";
import SimilarProperties from "../components/PropertyDetails/SimilarProperties/SimilarProperties";
import LocRatingMap from "../components/map/loc-rating-map-details"
import MemberForm from "../components/forms/member-form"
import Layout from "../components/layout";
import SEO from "../components/seo";

import { propertyDetH1, propertyDetDesc, propertyDetImage } from "../components/property-search/propertyDetailsSEO";
import ContactStickyNav from "../components/PropertyDetails/StickyNav/ContactStickyNav";
import EnquirySticky from "../components/PropertyDetails/StickyNav/EnquirySticky";
import NotFoundPage from "../pages/404";
import ContactVendor from "../components/PropertyDetails/ContactVendor/ContactVendor";

const PropertyDetailsTemplate = (props) => {

    const { glstrapi } = useStaticQuery(graphql`
        query PropertyDetailsGlobalModuleQuery {
            glstrapi {
                globalModule {
                    Auction_Details {
                        Joint_Auctioneer
                        Make_An_Offer
                        Notice_Bidder_Content
                        Purchase_Legal_Summary
                        Register_To_Bid
                        View_Legal_Documents
                        id
                    }
                }
            }
        }
    `)
    const globalModule = glstrapi?.globalModule;
    const auctionDetails = globalModule?.Auction_Details;
    const safeAuctionDetails = auctionDetails ? {
        ...auctionDetails,
        Joint_Auctioneer: Array.isArray(auctionDetails.Joint_Auctioneer?.data)
            ? auctionDetails.Joint_Auctioneer.data
            : [],
    } : null;

    const [search, setSearch] = useState(false);
    const [open, setOpen] = useState(false);
    const [menu_heading, setMenuHeading] = useState(false);
    const [state, setState] = React.useState({ showMenu: false });

    const [isOpen, setIsOpen] = useState(false);
    const [membDet, setMembDet] = useState('');
    const [popupType, setPopupType] = useState('');

    const MemberPopup = (item, popupType) => {
        setPopupType(popupType);
        setMembDet(item);
        setIsOpen(true);
    }

    useEffect(() => {
        $("body").removeClass("overflow-hidden")
    })

    const handlerClick = () => {
        setState({ ...state, showMenu: !state.showMenu });
        if (state.showMenu == true) {
            document.body.className = "";
        } else {
            document.body.classList.add("overflow-hidden");
        }
    };

    const openHam = () => { setOpen(!open); };

    const openSearch = (menu_title) => {
        setSearch(!search);
        handlerClick();
        setMenuHeading(menu_title)
    };
    const closeSearch = () => {
        setSearch(!search);
        handlerClick();
    };

    const data = props.pageContext?.propertyData;
    if (!data) { return <NotFoundPage /> }

    var page_url = props.location?.state?.page_url ? props.location?.state?.page_url : "";
    var lot_no = props.location?.state?.lot_no ? props.location?.state?.lot_no : "";

    var pop_slug = "buying";
    if (data.department === "residential" && data.search_type === "sales") {
        pop_slug = "buying";
    } else if (data.department === "residential" && data.search_type === "lettings") {
        pop_slug = "renting";
    } else if (data.department === "commercial") {
        pop_slug = "commercial";
    } else if (data.department === "auction_commercial" || data.department === "auction_residential") {
        pop_slug = "auctions";
    }

    var meta_title = propertyDetH1(data);
    var meta_desc = propertyDetDesc(data);
    var meta_img = propertyDetImage(data);

    let mapItems = [];
    let mapItem = {};
    mapItem['lat'] = data.latitude;
    mapItem['lng'] = data.longitude;
    mapItem['id'] = data.id;
    mapItems.push(mapItem);

    var area = data.address?.address3 ? data.address?.address3 : data.address?.address2 ? data.address?.address2 : data.address?.address1;

    return (
        <Layout GQLPage="" Layout="Without_Banner" classNames={`search-header person-header details-header ${pop_slug && `${pop_slug}-prop-details`}`} closeSearch={closeSearch} handlerClick={handlerClick} menu_heading={menu_heading} search={search} open={open} popular_search_slug={pop_slug}>

            {(data.department === "auction_residential" || data.department === "auction_commercial") &&
                <Helmet>
                    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10810490027"></script>
                </Helmet>
            }

            <SEO title={meta_title} description={meta_desc} image={meta_img} />
            {(data.department === "auction_residential" || data.department === "auction_commercial") && <BannerBottom />}
            <PropertyNav propertyData={data} page_url={page_url} />
            <StickyNav propertyData={data} />
            <ContactStickyNav propertyData={data} />
            <Avenue propertyData={data} lot_no={lot_no} globalModule={safeAuctionDetails} />
            <ContactVendor propertyVendor={data?.extra?.contacts} />
            <Description propertyData={data} globalModule={safeAuctionDetails} />
            {
                data?.status === "For Sale" && data?.department === "residential" &&
                <Calculator calc_price={data.max_price} property_type={data.department.replace('auction_', '')} />
            }
            <div className="property-details-landing-map mt-5" id="property-details-map">
                <LocRatingMap data={mapItems} sold_price_tab={data?.department === "commercial" ? false : true} />
            </div>

            {data?.status?.toLowerCase() !== "sold" && data?.status?.toLowerCase() !== "let" &&
                <Connect propertyData={data} openSearch={openSearch} openHam={openHam} search={search} open={open} location={props.location} globalModule={safeAuctionDetails} />
            }
            <SimilarProperties propertyData={data} area={area} department={data.department} MemberPopup={MemberPopup} />
            {data?.status?.toLowerCase() !== "sold" && data?.status?.toLowerCase() !== "let" &&
                <EnquirySticky />
            }

            {
                popupType &&
                <Modal
                    id="popup_modal_form"
                    show={isOpen}
                    onHide={() => setIsOpen(false)}
                    backdrop="static"
                    keyboard={false}
                    className="member-contact-modal"
                >
                    {
                        popupType === "Member_Form" && <>
                            <Modal.Header closeButton className="contact-close-btn memberPopup">
                                <Modal.Title className="w-100"><h3 className="text-center content-primary-color mb-0">Contact - {membDet.Name}</h3></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <MemberForm to_email_id={membDet.Email_ID} to_user_id={membDet.Form_Queue_ID} formName={`Individual Contact - ${membDet.Name}`} formLabel={`Person ${membDet.Name}`} />
                            </Modal.Body>
                        </>
                    }
                </Modal>
            }
        </Layout>
    )
}

export default PropertyDetailsTemplate
